module.exports = "/assets/data/83a1f0b073debbb13d966cfb81fa5b93-MK14.data.json";